import { CheckboxItem } from "../../CommonCheckboxGroup";













// Medical & Therapy History Checkbox Items

// CAGE QUESTIONS CHECKBOX CONSTANT

// Past Psychodynamic / Medical / Substance Use history sections
// rendered with the same card UI as the Physical Assessment sections
type PsychiatricHistoryKey =
  | "pastPsychodynamicHistory"
  | "psychMedicalHistory"
  | "substanceUseHistory"
  | "familyPsychiatricHistory"
  | "socialHistory";

const PAST_PSYCHODYNAMIC_HISTORY_ITEMS: CheckboxItem[] = [
  {
    name: "previousPsychiatricDiagnoses",
    label: "Previous psychiatric diagnoses",
  },
  {
    name: "priorPsychiatricHospitalizations",
    label: "Prior psychiatric hospitalizations",
  },
  {
    name: "previousPsychiatricTreatment",
    label: "Previous psychiatric treatment",
  },
  { name: "historyOfSelfHarm", label: "History of self-harm" },
  { name: "priorSuicideAttempts", label: "Prior suicide attempts" },
  {
    name: "previousPsychotropicMedications",
    label: "Previous psychotropic medications",
  },
  { name: "outpatientTherapyHistory", label: "Outpatient therapy history" },
];

const MEDICAL_HISTORY_CONDITION_ITEMS: CheckboxItem[] = [
  { name: "hypertension", label: "Hypertension" },
  { name: "diabetes", label: "Diabetes" },
  { name: "thyroidDisorder", label: "Thyroid disorder" },
  { name: "neurologicalConditions", label: "Neurological conditions" },
  { name: "chronicPain", label: "Chronic pain" },
  { name: "cardiovascularDisease", label: "Cardiovascular disease" },
  { name: "respiratoryConditions", label: "Respiratory conditions" },
  { name: "currentMedications", label: "Current medications" },
  { name: "surgicalHistory", label: "Surgical history" },
  { name: "allergies", label: "Allergies" },
];

const SUBSTANCE_USE_HISTORY_ITEMS: CheckboxItem[] = [
  { name: "tobaccoUse", label: "Tobacco use" },
  { name: "alcoholUse", label: "Alcohol use" },
  { name: "cannabisUse", label: "Cannabis use" },
  { name: "stimulantUse", label: "Stimulant use" },
  { name: "opioidUse", label: "Opioid use" },
  { name: "benzodiazepineUse", label: "Benzodiazepine use" },
  { name: "otherSubstanceUse", label: "Other substance use" },
  { name: "caffeineIntake", label: "Caffeine intake" },
  { name: "historyOfWithdrawal", label: "History of withdrawal" },
  { name: "priorSubstanceUseTreatment", label: "Prior substance use treatment" },
];

const FAMILY_PSYCHIATRIC_HISTORY_ITEMS: CheckboxItem[] = [
  { name: "depression", label: "Depression" },
  { name: "anxietyDisorders", label: "Anxiety disorders" },
  { name: "bipolarDisorder", label: "Bipolar disorder" },
  { name: "schizophreniaPsychosis", label: "Schizophrenia/psychosis" },
  { name: "substanceUseDisorders", label: "Substance use disorders" },
  { name: "suicideHistory", label: "Suicide history" },
  { name: "adhd", label: "ADHD" },
  { name: "personalityDisorders", label: "Personality disorders" },
  { name: "ptsd", label: "PTSD" },
];

const SOCIAL_HISTORY_ITEMS: CheckboxItem[] = [
  { name: "marriedPartnered", label: "Married/partnered" },
  { name: "single", label: "Single" },
  { name: "divorcedSeparated", label: "Divorced/separated" },
  { name: "employedFullTime", label: "Employed full-time" },
  { name: "employedPartTime", label: "Employed part-time" },
  { name: "unemployed", label: "Unemployed" },
  { name: "student", label: "Student" },
  { name: "livesAlone", label: "Lives alone" },
  { name: "livesWithFamily", label: "Lives with family" },
  { name: "stableHousing", label: "Stable housing" },
  { name: "strongSocialSupport", label: "Strong social support" },
  { name: "limitedSocialSupport", label: "Limited social support" },
  { name: "legalHistoryPresent", label: "Legal history present" },
];

export type PsychiatricHistorySectionDef = {
  key: PsychiatricHistoryKey;
  label: string;
  items: CheckboxItem[];
};

export const PSYCHIATRIC_HISTORY_SECTIONS: PsychiatricHistorySectionDef[] = [
  {
    key: "pastPsychodynamicHistory",
    label: "Past Psychodynamic History",
    items: PAST_PSYCHODYNAMIC_HISTORY_ITEMS,
  },
  {
    key: "psychMedicalHistory",
    label: "Medical History",
    items: MEDICAL_HISTORY_CONDITION_ITEMS,
  },
  {
    key: "substanceUseHistory",
    label: "Substance Use History",
    items: SUBSTANCE_USE_HISTORY_ITEMS,
  },
  {
    key: "familyPsychiatricHistory",
    label: "Family Psychiatric History",
    items: FAMILY_PSYCHIATRIC_HISTORY_ITEMS,
  },
  {
    key: "socialHistory",
    label: "Social History",
    items: SOCIAL_HISTORY_ITEMS,
  },
];










